import cn from 'classnames';
import { Link } from 'react-router-dom';
import { Heading } from '../../../../ui/components/Heading/Heading';
import { ArticleCard } from '../../OtherServices/OtherServices';
import { Icon } from '../../../../ui/components/Icon/Icon';

import styles from './ServiceCard.module.scss';

interface ServiceCardProps extends ArticleCard {
  isNew?: boolean;
  classname?: string;
  serviceNumber: string;
  summary: string;
}

export const ServiceCard = ({
  img,
  title,
  to,
  classname,
  isNew,
  serviceNumber,
  summary,
}: ServiceCardProps) => {
  return (
    <li className={cn(styles.root, classname)}>
      <Link className={styles.link} to={to || '/'}>
        <span className={styles.image}>
          <img loading="lazy" src={img} alt={title} />
        </span>
        <span className={styles.content}>
          <span className={styles.meta}>
            <span>Article {serviceNumber}</span>
            {isNew && <span className={styles.badge}>Featured</span>}
          </span>
          <Heading className={styles.title} headingLevel="h3">
            {title}
          </Heading>
          <span className={styles.summary}>{summary}</span>
          <span className={styles.action}>
            Read note
            <Icon type="right-arrow" alt="Read note" classname={styles.icon} />
          </span>
        </span>
      </Link>
    </li>
  );
};
